import { ReactNode, CSSProperties } from 'react';

import cx from 'classnames';

import s from './MediaIcon.module.scss';

interface IProps {
  style?: CSSProperties;
  children?: ReactNode;
  rounded?: boolean;
}

const MediaIcon: React.FC<IProps> = ({ rounded = true, style, children }) => (
  <div
    style={style}
    className={cx('icon', s.icon, {
      [s.rounded]: rounded,
    })}
  >
    {children}
  </div>
);

export default MediaIcon;
